{
  "labels": {
    "paste": "貼上",
    "pasteAsPlaintext": "以純文字貼上",
    "pasteCharts": "貼上圖表",
    "selectAll": "全選",
    "multiSelect": "將物件加入選取範圍",
    "moveCanvas": "移動畫布",
    "cut": "剪下",
    "copy": "複製",
    "copyAsPng": "以PNG格式儲存到剪貼板",
    "copyAsSvg": "以SVG格式複製到剪貼板",
    "copyText": "以文字格式複製至剪貼簿",
    "copySource": "複製來源至剪貼簿",
    "convertToCode": "轉換為程式碼",
    "bringForward": "上移一層",
    "sendToBack": "移到最底層",
    "bringToFront": "置於最頂層",
    "sendBackward": "往後移一層",
    "delete": "刪除",
    "copyStyles": "複製樣式",
    "pasteStyles": "貼上樣式",
    "stroke": "筆畫",
    "background": "背景",
    "fill": "填滿",
    "strokeWidth": "筆跡寬度",
    "strokeStyle": "筆畫樣式",
    "strokeStyle_solid": "實線",
    "strokeStyle_dashed": "虛線",
    "strokeStyle_dotted": "點線",
    "sloppiness": "線條風格",
    "opacity": "透明度",
    "textAlign": "文字對齊",
    "edges": "邊緣",
    "sharp": "尖銳",
    "round": "平滑",
    "arrowheads": "箭頭",
    "arrowhead_none": "無",
    "arrowhead_arrow": "箭頭",
    "arrowhead_bar": "條狀箭頭",
    "arrowhead_circle": "圓形",
    "arrowhead_circle_outline": "圓形（外框）",
    "arrowhead_triangle": "三角形",
    "arrowhead_triangle_outline": "三角形（外框）",
    "arrowhead_diamond": "菱形",
    "arrowhead_diamond_outline": "菱形（外框）",
    "fontSize": "字型大小",
    "fontFamily": "字體集",
    "addWatermark": "加上 \"Made with Excalidraw\" 浮水印",
    "handDrawn": "手寫",
    "normal": "一般",
    "code": "代碼",
    "small": "小",
    "medium": "中",
    "large": "大",
    "veryLarge": "特大",
    "solid": "實心",
    "hachure": "斜線筆觸",
    "zigzag": "Ｚ字形",
    "crossHatch": "交叉筆觸",
    "thin": "細",
    "bold": "粗",
    "left": "左側",
    "center": "置中",
    "right": "右側",
    "extraBold": "極粗",
    "architect": "精確",
    "artist": "藝術",
    "cartoonist": "卡通",
    "fileTitle": "檔案名稱",
    "colorPicker": "色彩選擇工具",
    "canvasColors": "使用於畫布",
    "canvasBackground": "Canvas 背景",
    "drawingCanvas": "繪圖 canvas",
    "layers": "圖層",
    "actions": "動作",
    "language": "語言",
    "liveCollaboration": "即時協作...",
    "duplicateSelection": "複製",
    "untitled": "無標題",
    "name": "名稱",
    "yourName": "你的名稱",
    "madeWithExcalidraw": "以 Excalidraw 製作",
    "group": "建立群組",
    "ungroup": "取消群組",
    "collaborators": "協作者",
    "showGrid": "顯示格線",
    "addToLibrary": "加入資料庫",
    "removeFromLibrary": "從資料庫中移除",
    "libraryLoadingMessage": "資料庫讀取中…",
    "libraries": "瀏覽資料庫",
    "loadingScene": "場景讀取中…",
    "align": "對齊",
    "alignTop": "對齊頂部",
    "alignBottom": "對齊底部",
    "alignLeft": "對齊左側",
    "alignRight": "對齊右側",
    "centerVertically": "垂直置中",
    "centerHorizontally": "水平置中",
    "distributeHorizontally": "水平分布",
    "distributeVertically": "垂直分布",
    "flipHorizontal": "水平翻轉",
    "flipVertical": "垂直翻轉",
    "viewMode": "檢視模式",
    "share": "共享",
    "showStroke": "顯示線條檢色器",
    "showBackground": "顯示背景檢色器",
    "toggleTheme": "切換主題",
    "personalLib": "個人資料庫",
    "excalidrawLib": "Excalidraw 資料庫",
    "decreaseFontSize": "縮小文字",
    "increaseFontSize": "放大文字",
    "unbindText": "取消綁定文字",
    "bindText": "結合文字至容器",
    "createContainerFromText": "將文字包於容器中",
    "link": {
      "edit": "編輯連結",
      "editEmbed": "編輯連結&嵌入",
      "create": "建立連結",
      "createEmbed": "建立連結&嵌入",
      "label": "連結",
      "labelEmbed": "連結&嵌入",
      "empty": "未設定連結"
    },
    "lineEditor": {
      "edit": "編輯線條",
      "exit": "結束線條編輯"
    },
    "elementLock": {
      "lock": "鎖定",
      "unlock": "解鎖",
      "lockAll": "全部鎖定",
      "unlockAll": "全部解鎖"
    },
    "statusPublished": "已發布",
    "sidebarLock": "側欄維持開啟",
    "selectAllElementsInFrame": "選取框架內的所有元素",
    "removeAllElementsFromFrame": "從框架內移除所有元素",
    "eyeDropper": "從畫布中選取顏色",
    "textToDiagram": "文字轉圖表",
    "prompt": "提示詞"
  },
  "library": {
    "noItems": "尚未加入任何物件...",
    "hint_emptyLibrary": "選取畫布上的物件以加入，或從下方的公開 repository 中安裝資料庫",
    "hint_emptyPrivateLibrary": "選擇畫布上的物件以在此加入"
  },
  "buttons": {
    "clearReset": "重置 canvas",
    "exportJSON": "匯出至檔案",
    "exportImage": "匯出圖片",
    "export": "儲存至...",
    "copyToClipboard": "複製至剪貼簿",
    "save": "儲存目前檔案",
    "saveAs": "儲存為",
    "load": "開啟",
    "getShareableLink": "取得共享連結",
    "close": "關閉",
    "selectLanguage": "選擇語言",
    "scrollBackToContent": "捲動回到內容",
    "zoomIn": "放大",
    "zoomOut": "縮小",
    "resetZoom": "重設縮放",
    "menu": "選單",
    "done": "完成",
    "edit": "編輯",
    "undo": "復原",
    "redo": "重做",
    "resetLibrary": "重設資料庫",
    "createNewRoom": "建立新協作會議室",
    "fullScreen": "全螢幕",
    "darkMode": "深色模式",
    "lightMode": "淺色模式",
    "zenMode": "專注模式",
    "objectsSnapMode": "吸附至物件",
    "exitZenMode": "離開專注模式",
    "cancel": "取消",
    "clear": "清除",
    "remove": "刪除",
    "embed": "切換嵌入",
    "publishLibrary": "發布",
    "submit": "送出",
    "confirm": "確認",
    "embeddableInteractionButton": "點擊以互動"
  },
  "alerts": {
    "clearReset": "這將會清除整個 canvas。你確定嗎？",
    "couldNotCreateShareableLink": "無法建立共享連結。",
    "couldNotCreateShareableLinkTooBig": "無法建立共享連結：場景太大",
    "couldNotLoadInvalidFile": "無法讀取失效的檔案。",
    "importBackendFailed": "後端讀取失敗。",
    "cannotExportEmptyCanvas": "無法輸出空白的 canvas。",
    "couldNotCopyToClipboard": "無法複製到剪貼簿",
    "decryptFailed": "無法解密資料。",
    "uploadedSecurly": "上傳已通過 end-to-end 加密，Excalidraw 伺服器和第三方無法皆讀取其內容。",
    "loadSceneOverridePrompt": "讀取外部圖樣將取代目前的內容。是否要繼續？",
    "collabStopOverridePrompt": "停止連線將覆蓋您先前於本機儲存的繪圖進度，是否確認？\n\n（如要保留原有的本機繪圖進度，直接關閉瀏覽器分頁即可。）",
    "errorAddingToLibrary": "無法於此資料庫加入項目",
    "errorRemovingFromLibrary": "無法由此資料庫移除項目",
    "confirmAddLibrary": "這將會將 {{numShapes}} 個圖形加入你的資料庫，你確定嗎？",
    "imageDoesNotContainScene": "此圖檔中未包含場景資料。輸出檔案時是否有包含場景資料？",
    "cannotRestoreFromImage": "無法由此檔案回復場景。",
    "invalidSceneUrl": "無法由提供的 URL 匯入場景。可能是發生異常，或未包含有效的 Excalidraw JSON 資料。",
    "resetLibrary": "這會清除您的資料庫，是否確定？",
    "removeItemsFromsLibrary": "從資料庫刪除 {{count}} 項？",
    "invalidEncryptionKey": "加密鍵必須為22字元。即時協作已停用。",
    "collabOfflineWarning": "沒有可用的網路連線。\n變更無法儲存！"
  },
  "errors": {
    "unsupportedFileType": "不支援的檔案類型。",
    "imageInsertError": "無法插入圖片。請稍後再試…",
    "fileTooBig": "檔案過大。可接受的最大尺寸為 {{maxSize}} 。",
    "svgImageInsertError": "無法插入 SVG 圖片。此 SVG 檔案有問題。",
    "failedToFetchImage": "無法獲取圖片。",
    "invalidSVGString": "無效的 SVG。",
    "cannotResolveCollabServer": "無法連結至 collab 伺服器。請重新整理後再試一次。",
    "importLibraryError": "無法載入資料庫",
    "collabSaveFailed": "無法儲存至後端資料庫。若此問題持續發生，請將檔案儲存於本機以確保資料不會遺失。",
    "collabSaveFailed_sizeExceeded": "無法儲存至後端資料庫，可能的原因為畫布尺寸過大。請將檔案儲存於本機以確保資料不會遺失。",
    "imageToolNotSupported": "圖片已停用",
    "brave_measure_text_error": {
      "line1": "看起來您開啟了 Brave 瀏覽器的 <bold>Aggressively Block Fingerprinting</bold> 設定。",
      "line2": "這可能造成您畫布中 <bold>文字元素</bold> 的異常。",
      "line3": "我們強烈建議您關閉此設定。您可以依照 <link>這些步驟</link> 來進行。",
      "line4": "若關閉此設定並未修復文字元素的顯示問題，請回報於我們 GitHub 上的 <issueLink>issue</issueLink>，或在 <discordLink>Discord</discordLink> 上告訴我們。"
    },
    "libraryElementTypeError": {
      "embeddable": "可嵌入元素無法加入資料庫",
      "iframe": "IFrame 元素無法加入資料庫",
      "image": "即將支援加入圖片至資料庫！"
    },
    "asyncPasteFailedOnRead": "無法貼上（無法由系統剪貼簿讀入）",
    "asyncPasteFailedOnParse": "無法貼上",
    "copyToSystemClipboardFailed": "無法複製至剪貼簿"
  },
  "toolBar": {
    "selection": "選取",
    "image": "插入圖片",
    "rectangle": "長方形",
    "diamond": "菱形",
    "ellipse": "橢圓",
    "arrow": "箭頭",
    "line": "線條",
    "freedraw": "繪圖",
    "text": "文字",
    "library": "資料庫",
    "lock": "可連續使用選取的工具",
    "penMode": "筆模式 - 避免觸摸",
    "link": "為所選的形狀增加\b/更新連結",
    "eraser": "橡皮擦",
    "frame": "框架工具",
    "magicframe": "線框稿轉為程式碼",
    "embeddable": "嵌入網站",
    "laser": "雷射筆",
    "hand": "手形（平移工具）",
    "extraTools": "更多工具",
    "mermaidToExcalidraw": "Mermaid 至 Excalidraw",
    "magicSettings": "AI 設定"
  },
  "headings": {
    "canvasActions": "canvas 動作",
    "selectedShapeActions": "選取圖形動作",
    "shapes": "形狀"
  },
  "hints": {
    "canvasPanning": "若要移動畫布，請在拖曳時按住滑鼠滾輪或空白鍵，或使用手形工具",
    "linearElement": "點擊以繪製多點曲線；或拖曳以繪製直線",
    "freeDraw": "點擊並拖曳來繪圖，放開即結束",
    "text": "提示：亦可使用選取工具在任何地方雙擊來加入文字",
    "embeddable": "點擊並拖移以建立嵌入網站",
    "text_selected": "雙擊滑鼠或按 Enter 以編輯文字",
    "text_editing": "按跳脫鍵或 Ctrl 或 Cmd + Enter 以結束編輯",
    "linearElementMulti": "按下 Escape 或 Enter 以結束繪製",
    "lockAngle": "按住 SHIFT 可限制旋轉角度",
    "resize": "縮放時按住 Shift 可保持原比例縮放；\\n按住 Alt 可由中心點進行縮放",
    "resizeImage": "按住 SHIFT 可任意縮放，按住 ALT 可由中央縮放。",
    "rotate": "旋轉時按住 Shift 可限制旋轉角度",
    "lineEditor_info": "按住 Ctrl 或 Cmd 並雙擊或按住 Ctrl 或 Cmd + Enter 來編輯控制點",
    "lineEditor_pointSelected": "按下 Delete 可移除錨點；Ctrl 或 Cmd + D 可複製；或可拖曳來移動",
    "lineEditor_nothingSelected": "選擇要編輯的錨點（按住 SHIFT 可多選），\n或按住 Alt 並點擊以增加新錨點。",
    "placeImage": "點擊以放置圖片，或點擊並拖曳以手動調整其尺寸。",
    "publishLibrary": "發布個人資料庫",
    "bindTextToElement": "按下 Enter 以加入文字。",
    "deepBoxSelect": "按住 Ctrl 或 Cmd 以深度選取並避免拖曳",
    "eraserRevert": "按住 Alt 以反選取已標記待刪除的元素",
    "firefox_clipboard_write": "此功能有機會透過將 \"dom.events.asyncClipboard.clipboardItem\" 設定為 \"true\" 來開啟。\n若要變更 Firefox 瀏覽器的此設定值，請至 \"about:config\" 頁面。",
    "disableSnapping": "按住 Ctrl 或 Cmd 以禁用吸附"
  },
  "canvasError": {
    "cannotShowPreview": "無法顯示預覽",
    "canvasTooBig": "畫布可能過大",
    "canvasTooBigTip": "提示：可嘗試將最遠的元素移動至較集中的位置"
  },
  "errorSplash": {
    "headingMain": "發生錯誤，嘗試<button>重新載入頁面。</button>",
    "clearCanvasMessage": "若重新載入仍無法解決問題，嘗試<button>清除 canvas。</button>",
    "clearCanvasCaveat": "此動作將造成目前的作品被移除。",
    "trackedToSentry": "此錯誤與其識別碼{{eventId}}將由系統記錄。",
    "openIssueMessage": "我們將謹慎處理，你的作品內容不會被包含在錯誤報告中。若你的作品不需保持私密，請考慮使用我們的<button>bug tracker。</button>請將下列資訊複製貼上至 GitHub issue 中。",
    "sceneContent": "作品內容："
  },
  "roomDialog": {
    "desc_intro": "你可以邀請其他人一起協作目前的作品。",
    "desc_privacy": "連線使用 end-to-end 加密故無須擔心作品的安全性。即使是我們的伺服器也無法取得其內容。",
    "button_startSession": "開始連線",
    "button_stopSession": "停止連線",
    "desc_inProgressIntro": "即時協作連線正在進行中。",
    "desc_shareLink": "將此連結分享給欲協作的對象：",
    "desc_exitSession": "停止連線將中斷你與協作會議室的連結，但你仍可於本機編輯此作品。意指停止連線後你的編輯不會被先前共同協作的人看見，且他們可繼續共同協作另一個版本。",
    "shareTitle": "加入 Excalidraw 上的即時協作會議室"
  },
  "errorDialog": {
    "title": "錯誤"
  },
  "exportDialog": {
    "disk_title": "儲存至硬碟",
    "disk_details": "將場景匯出為可供匯入之檔案",
    "disk_button": "儲存至檔案",
    "link_title": "可共享連結",
    "link_details": "匯出為唯讀連結",
    "link_button": "匯出為連結",
    "excalidrawplus_description": "將此場景儲存至你的 Excalidraw+ 工作區",
    "excalidrawplus_button": "輸出",
    "excalidrawplus_exportError": "目前無法輸出至 Excalidraw+"
  },
  "helpDialog": {
    "blog": "閱讀部落格",
    "click": "點擊",
    "deepSelect": "深度選取",
    "deepBoxSelect": "在容器內深度選取並避免拖曳",
    "curvedArrow": "曲箭頭",
    "curvedLine": "曲線",
    "documentation": "文件",
    "doubleClick": "雙擊",
    "drag": "拖曳",
    "editor": "編輯器",
    "editLineArrowPoints": "編輯線/箭頭控制點",
    "editText": "編輯文字/增加標籤",
    "github": "發現異常？回報問題",
    "howto": "參照我們的說明",
    "or": "或",
    "preventBinding": "避免箭號連結",
    "tools": "工具",
    "shortcuts": "鍵盤快速鍵",
    "textFinish": "完成編輯（文字編輯器）",
    "textNewLine": "換行（文字編輯器）",
    "title": "說明",
    "view": "檢視",
    "zoomToFit": "放大至填滿畫面",
    "zoomToSelection": "縮放至選取區",
    "toggleElementLock": "鎖定/解鎖已選的項目",
    "movePageUpDown": "向上/下移動頁面",
    "movePageLeftRight": "向左/右移動頁面"
  },
  "clearCanvasDialog": {
    "title": "清除畫布"
  },
  "publishDialog": {
    "title": "發布資料庫",
    "itemName": "項目名稱",
    "authorName": "作者名稱",
    "githubUsername": "GitHub 帳號",
    "twitterUsername": "Twitter 帳號",
    "libraryName": "資料庫名稱",
    "libraryDesc": "資料庫說明",
    "website": "網站",
    "placeholder": {
      "authorName": "您的名稱或帳號",
      "libraryName": "您的資料庫名稱",
      "libraryDesc": "提供您的資料庫說明以利他人理解其用途",
      "githubHandle": "Github handle（選填），填寫後您可編輯已送出待審查的資料庫",
      "twitterHandle": "Twitter 帳號（選填），填寫後若我們在 Twitter 推廣時可提及您",
      "website": "您個人網站或其他網站的連結（選填）"
    },
    "errors": {
      "required": "必填",
      "website": "請輸入有效的 URL"
    },
    "noteDescription": "送出您的資料庫後將被包含於<link>公開資料庫 repository</link>以利他人在其繪圖中使用。",
    "noteGuidelines": "資料庫需先經人工審查。請閱讀<link>說明文件</link>再送出。若需溝通與修改時要透過 GitHub 帳號來進行，但並非強制需求。",
    "noteLicense": "送出即代表您同意此資料庫將發布時使用 <link>MIT 授權，</link>簡單來說是指任何人都能不受限制的使用。",
    "noteItems": "每個資料庫項目都有獨立的名稱故可篩選。會包含下列資料庫項目：",
    "atleastOneLibItem": "請選擇至少一項資料庫項目",
    "republishWarning": "注意：部分選取中的物件先前已發布/送出過。建議僅在要更新現存資料庫或已送出的物件時才重新送出這些物件。"
  },
  "publishSuccessDialog": {
    "title": "資料庫已送出",
    "content": "感謝 {{authorName}} 。您的資料庫已送出待審查。您可查看目前狀態<link>在此</link>"
  },
  "confirmDialog": {
    "resetLibrary": "重設資料庫",
    "removeItemsFromLib": "從資料庫移除所選的項目"
  },
  "imageExportDialog": {
    "header": "匯出圖片",
    "label": {
      "withBackground": "背景",
      "onlySelected": "僅選取物件",
      "darkMode": "深色模式",
      "embedScene": "嵌入場景",
      "scale": "縮放比例",
      "padding": "內間距"
    },
    "tooltip": {
      "embedScene": "用於回復場景的場景資料會被包含在輸出的 PNG/SVG 檔案中。\n會增加輸出的檔案大小。"
    },
    "title": {
      "exportToPng": "輸出成 PNG",
      "exportToSvg": "輸出成 SVG",
      "copyPngToClipboard": "複製 PNG 至剪貼簿"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "複製至剪貼簿"
    }
  },
  "encrypted": {
    "tooltip": "你的作品已使用 end-to-end 方式加密，Excalidraw 的伺服器也無法取得其內容。",
    "link": "Excalidraw 端到端加密的相關部落格文章"
  },
  "stats": {
    "angle": "角度",
    "element": "元素",
    "elements": "元素",
    "height": "高度",
    "scene": "場景",
    "selected": "已選",
    "storage": "儲存",
    "title": "詳細統計",
    "total": "合計",
    "version": "版本",
    "versionCopy": "點擊複製",
    "versionNotAvailable": "無法取得版本",
    "width": "寬度"
  },
  "toast": {
    "addedToLibrary": "加入資料庫",
    "copyStyles": "已複製樣式",
    "copyToClipboard": "複製至剪貼簿。",
    "copyToClipboardAsPng": "以 PNG 格式將 {{exportSelection}} 複製至剪貼簿\n({{exportColorScheme}})",
    "fileSaved": "已儲存檔案。",
    "fileSavedToFilename": "儲存為 {filename}",
    "canvas": "畫布",
    "selection": "已選項目",
    "pasteAsSingleElement": "使用 {{shortcut}} 以做為單一物件貼上，\n或貼上至現有的文字編輯器",
    "unableToEmbed": "目前不允許嵌入此網址。您可至 GitHub 提出 issue 以要求將此網址加入合格名單。",
    "unrecognizedLinkFormat": "您嵌入的連結格式不符。請嘗試貼入原網站所提供的「嵌入」字串。"
  },
  "colors": {
    "transparent": "透明",
    "black": "黑",
    "white": "白",
    "red": "紅",
    "pink": "粉紅",
    "grape": "深紫",
    "violet": "藍紫",
    "gray": "灰",
    "blue": "藍",
    "cyan": "青",
    "teal": "藍綠",
    "green": "綠",
    "yellow": "黃",
    "orange": "橘",
    "bronze": "銅"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "所有資料皆已在瀏覽器中儲存於本機",
      "center_heading_plus": "您是否是要前往 Excalidraw+ ？",
      "menuHint": "輸出、偏好設定、語言..."
    },
    "defaults": {
      "menuHint": "輸出、偏好設定及其他...",
      "center_heading": "圖表。製作。超簡單。",
      "toolbarHint": "選個工具開始畫圖吧！",
      "helpHint": "快速鍵與說明"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "最常使用的自訂顏色",
    "colors": "顏色",
    "shades": "漸變色",
    "hexCode": "Hex 碼",
    "noShades": "沒有此顏色的漸變色"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "匯出為圖片",
        "button": "匯出為圖片",
        "description": "將場景匯出為可供匯入的圖片檔案"
      },
      "saveToDisk": {
        "title": "儲存至硬碟",
        "button": "儲存至硬碟",
        "description": "將場景匯出為可供匯入的檔案"
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "匯出至 Excalidraw+",
        "description": "將此場景儲存至您的 Excalidraw+ 工作區"
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "從檔案載入",
        "button": "從檔案載入",
        "description": "從檔案載入將<bold>取代您目前的內容</bold>。<br></br>可先使用下方的選項備份您的繪圖。"
      },
      "shareableLink": {
        "title": "從連結載入",
        "button": "取代我的內容",
        "description": "載入外部繪圖將<bold>取代您目前的內容</bold>。<br></br>可先使用下方的選項備份您的繪圖。"
      }
    }
  },
  "mermaid": {
    "title": "Mermaid 至 Excalidraw",
    "button": "插入",
    "description": "目前僅支援 <flowchartLink>Flowchart</flowchartLink> 、 <sequenceLink>Sequence</sequenceLink> 及 <classLink>Class </classLink> 圖表。其餘檔案類型在 Excalidraw 將會以圖像呈現。",
    "syntax": "Mermaid 語法",
    "preview": "預覽"
  }
}
